import { useContext } from "react";
import AssetContext from "./AssetContext";

const useAssetProvider = () => {
	const {
		isReadOnly,
		setIsRefresh,
		app,
		assets,
		updateAssets,
		assetDocuments,
		fees,
		vendors,
		locations,
		stateSalesTax,
		usStates,
		assetTypes,
		feeTypes,
		onAssetAdd,
		onAssetUpdate,
		onAssetDuplicate,
		onChangeAsset,
		onAssetDelete,
		getAssetDocuments,
		onFeeUpdate,
		onFeeAdd,
		onFeeDelete,
		onVendorAdd,
		getVendor,
		getVendors,
		getPDConfig,
		getAttachment,
		getPDValue,
		getEWConfig,
		getEWValue,
		setFeeTypeList
	} = useContext(AssetContext);
	return {
		isReadOnly,
		setIsRefresh,
		app,
		assets,
		updateAssets,
		assetDocuments,
		fees,
		vendors,
		locations,
		stateSalesTax,
		usStates,
		assetTypes,
		feeTypes,
		onAssetAdd,
		onFeeDelete,
		getAttachment,
		onAssetUpdate,
		onAssetDuplicate,
		onChangeAsset,
		onAssetDelete,
		getAssetDocuments,
		onFeeUpdate,
		onFeeAdd,
		onVendorAdd,
		getVendor,
		getVendors,
		getPDConfig,
		getPDValue,
		getEWConfig,
		getEWValue,
		setFeeTypeList
	};
};

export default useAssetProvider;
